<template>
  <div>
    <carousel :pagination-enabled="false" :per-page="1" :navigation-enabled="isNavigationEnabled">
      <slide v-for="(carouselItem, index) in message.carouselItems" :key="index">
        <div
          :class="{
            clickable: isItemClickable(isClickDisabled, carouselItem.payload, $getConst('MESSAGE_TYPES.CAROUSEL_ITEM'))
          }"
          class="prodInfo"
          @click="
            handleSlideClick(carouselItem.payload, carouselItem.mainContent, $getConst('MESSAGE_TYPES.CAROUSEL_ITEM'))
          ">
          <figure v-lazy-container="{ selector: 'img' }">
            <img v-if="carouselItem.images" :data-src="carouselItem.images[0]" />
            <figcaption>
              <h4>{{ carouselItem.mainContent }}</h4>
              <p v-if="carouselItem.extraContent">{{ carouselItem.extraContent }}</p>
            </figcaption>
          </figure>
          <h2
            v-if="carouselItem.statusInfo"
            :style="[carouselItem.statusInfo.color ? { color: carouselItem.statusInfo.color } : {}]">
            {{ carouselItem.statusInfo.content }}
          </h2>
          <div v-if="carouselItem.subContent" class="itemLines">
            <div v-for="(subContent, pos) in carouselItem.subContent" :key="pos" class="itemLine">
              <div v-on="subContent.url ? { click: $event => openLink($event, subContent.url) } : {}">
                <img v-if="subContent.image" :src="subContent.image" class="itemLineImage" />
                <div class="itemLineDetail" style="white-space: pre-line">
                  <h4 v-if="subContent.title">{{ subContent.title }}</h4>
                  <!--eslint-disable vue/no-v-html-->
                  <p v-if="subContent.description" v-html="formatMessage(subContent.description)"></p>
                  <!--eslint-enable vue/no-v-html-->
                </div>
              </div>
            </div>
          </div>
          <div v-if="carouselItem.buttons" class="carouselLinks">
            <a
              v-for="(button, pos) in carouselItem.buttons"
              :key="pos"
              :style="elementStyle"
              :data-payload="button.payload"
              :data-text="button.text"
              :class="{
                clickable: isItemClickable(isClickDisabled, button.payload, $getConst('MESSAGE_TYPES.CAROUSEL_BUTTON'))
              }"
              @click.stop.prevent="
                handleSlideClick(button.payload, button.text, $getConst('MESSAGE_TYPES.CAROUSEL_BUTTON'))
              ">
              {{ button.text }}
            </a>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import { mapGetters } from 'vuex'
import { mixin, isUrl } from '../../lib/utils'
import config from '../../config'

export default {
  name: 'CarouselItems',
  components: {
    Carousel,
    Slide
  },
  mixins: [mixin],
  props: {
    message: { type: Object, required: true },
    isNavigationEnabled: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    elementStyle: { type: [Object, Boolean], default: null },
    isAdmin: { type: Boolean, default: false },
    isKiosk: { type: Boolean, default: false }
  },
  data: function () {
    return {
      isClickDisabled: this.isDisabled
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale'
    })
  },
  methods: {
    isUrl,
    handleSlideClick: function (payload, mainContent, type) {
      if (!this.isKiosk && typeof payload !== 'undefined' && this.isUrl(payload)) {
        this.openLink(window.event, payload)
        return
      }

      if (!this.isKiosk && typeof mainContent !== 'undefined' && this.isUrl(mainContent)) {
        this.openLink(window.event, mainContent)
        return
      }

      if (!this.isItemClickable(this.isClickDisabled, payload, type)) {
        return
      }

      const message = [
        {
          messageType: 'message',
          mainContent: mainContent,
          payload: payload,
          inputType: config.INPUT_TYPES.TOUCH,
          intentAnalysed: null,
          actionDeduced: null,
          context: null
        }
      ]

      this.isClickDisabled = true
      this.$store.dispatch('socket_userMessage', message)
    },

    openLink: function (event, url) {
      event.preventDefault()

      if (!this.isKiosk) {
        const win = window.open(url, '_blank')
        win.focus()
      }
    },

    isItemClickable: function (isClickDisabled, payload, type) {
      return (
        !isClickDisabled &&
        (type === this.$getConst('MESSAGE_TYPES.CAROUSEL_BUTTON') ||
          (payload !== undefined &&
            payload !== null &&
            ((typeof payload === 'string' && payload.trim().length > 0) ||
              (payload.intentId !== null &&
                typeof payload.intentId === 'string' &&
                payload.intentId.trim().length > 0) ||
              (payload.url !== null && typeof payload.url === 'string' && payload.url.trim().length > 0))))
      )
    }
  }
}
</script>
